import Assistant from "../assistant/Assistant";
import styled from "styled-components";
import { BaseModal } from "./modalStyle";
import ExitButton from "../buttons/ExitButton";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import FormikControl from "../inputs/FormikControl";
import { loadStrategy, patchStrategy } from "../strategy/strategyAction";
import AlertMessage from "../alert/AlertMessage";
import { FunctionalModal } from "./FunctionalModal";
import SendFormButton from "../buttons/SendFormButton";

const StrategyModal = ({ value, setIsOpen }) => {
  const { vision, goal, success, mission, id } = useSelector(
    (state) => state.strategy
  );
  const [isSend, setIsSend] = useState(false);
  const [isNotSend, setIsNotSend] = useState(false);

  const dispatch = useDispatch();

  const close = () => {
    setIsOpen(false);
  };

  const getName = () => {
    if (value === "success") {
      return "nos valeurs";
    }
    if (value === "vision") {
      return "notre vision";
    }
    if (value === "goal") {
      return "notre ambition";
    }
    if (value === "duty") {
      return "notre mission";
    }
  };

  const getValue = (name) => {
    if (name === "success") {
      return success;
    }
    if (name === "vision") {
      return vision;
    }
    if (name === "goal") {
      return goal;
    }
    if (name === "duty") {
      return mission;
    }
  };

  const initialValues = {
    [value]: getValue(value),
  };

  const maxLengthString = 1000;

  const validationSchema = Yup.object({
    [value]: Yup.string().max(
      maxLengthString,
      "Ne peux contenir plus de 1000 caractères"
    ),
  });

  const handleSubmit = async (data) => {
    try {
      await dispatch(patchStrategy(id, data));
      setIsSend(true);
      await dispatch(loadStrategy());
      setIsOpen(false);
    } catch {
      setIsNotSend(true);
    }
  };

  const displayMessage = () => {
    if (isSend) {
      return (
        <AlertMessage
          title={"Opération effectuée avec succès !"}
          status={"success"}
        />
      );
    }
    if (isNotSend) {
      return (
        <AlertMessage title={"Une erreur s'est produite !"} status={"alert"} />
      );
    }
  };

  const displayModal = () => {
    return (
      <Modal>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isValid, isSubmitting, _, setFieldValue }) => (
            <>
              <div className={"flex-row w-100"}>
                <h1> Modifier {getName()}</h1>
                <ExitButton closeUpdate={close} />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Assistant
                  context={{
                    object: value,
                  }}
                  onSelect={(item) => {
                    setFieldValue(value, item.description);
                  }}
                />
              </div>

              <Form>
                <FormikControl
                  control={"textarea"}
                  label={"Description"}
                  name={value}
                />

                <SendFormButton
                  state={isValid && !isSubmitting}
                  actionName={"Modifier"}
                />
              </Form>
            </>
          )}
        </Formik>
      </Modal>
    );
  };
  return (
    <>
      {displayMessage()}
      <FunctionalModal setOpen={setIsOpen} component={displayModal()} />
    </>
  );
};

const Modal = styled(BaseModal)`
  align-items: center;
  height: fit-content;
  gap: 1rem;

  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
  }

  h1 {
    flex-grow: 1.5;
    text-align: center;
  }

  .exit-btn {
    align-self: flex-start;
  }

  @media (min-width: 900px) {
    width: 600px;
  }
`;

export default StrategyModal;
